(() => {
  const initDeferredHeroVideo = () => {
    const video = document.querySelector('[data-v2-hero-video]');
    if (!video || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const source = video.querySelector('source[data-src]');
    if (!source || source.src) return;

    const loadVideo = () => {
      source.src = source.dataset.src;
      video.load();
      video.play().catch(() => {});
    };

    const scheduleLoad = () => window.setTimeout(loadVideo, 1200);
    if (document.readyState === 'complete') scheduleLoad();
    else window.addEventListener('load', scheduleLoad, { once: true });
  };

  initDeferredHeroVideo();

  const header = document.querySelector('[data-v2-header]');
  const scrollTrack = (button) => {
    const track = document.getElementById(button.dataset.track);
    if (!track) return;
    const card = track.querySelector('a');
    const distance = (card?.getBoundingClientRect().width || 320) + 32;
    track.scrollBy({ left: Number(button.dataset.direction) * distance, behavior: 'smooth' });
  };
  const updateShopRow = (row) => {
    const panel = row.closest('[data-v2-shop-panel]');
    panel.querySelectorAll('[data-v2-shop-row]').forEach((item) => item.classList.toggle('is-active', item === row));
    const bg = panel.querySelector('[data-v2-shop-bg]');
    bg.style.setProperty('--shop-color', row.dataset.color);
    const image = bg.querySelector('img');
    if (image) {
      image.hidden = !row.dataset.image;
      if (row.dataset.image) image.src = row.dataset.image;
    }
    panel.querySelector('[data-v2-shop-category]').textContent = panel.dataset.v2ShopPanel === 'colour' ? 'Colour' : panel.dataset.v2ShopPanel;
    panel.querySelector('[data-v2-shop-name]').textContent = row.dataset.name;
    panel.querySelector('[data-v2-shop-tagline]').textContent = row.dataset.tagline || '';
    panel.querySelector('[data-v2-shop-cta]').textContent = `Shop ${row.dataset.name} →`;
    const hero = panel.querySelector('.home-v2-shop__hero');
    if (hero && row.dataset.url) hero.setAttribute('href', row.dataset.url);
  };
  const updateMegaAxis = (axis) => {
    const menu = axis.closest('[data-he-mega-menu]');
    if (!menu) return;
    menu.querySelectorAll('[data-he-mega-axis]').forEach((item) => {
      item.setAttribute('aria-current', String(item === axis));
    });
    menu.querySelectorAll('[data-he-mega-axis-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.heMegaAxisPanel !== axis.dataset.heMegaAxis;
    });
  };
  let roomTrigger = null;
  const getRoomFocusable = (overlay) => [...overlay.querySelectorAll(
    'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])',
  )].filter((element) => !element.closest('[hidden]'));
  const openRoomDialog = (trigger) => {
    const overlay = document.querySelector('[data-v2-room-overlay]');
    if (!overlay) return;
    roomTrigger = trigger;
    overlay.removeAttribute('hidden');
    overlay.querySelector('[data-v2-room-dialog]')?.focus();
  };
  const closeRoomDialog = (overlay) => {
    if (!overlay) return;
    overlay.setAttribute('hidden', '');
    roomTrigger?.focus();
    roomTrigger = null;
  };

  const activateShopTab = (tab, { focus = false } = {}) => {
    const section = tab.closest('[data-v2-shop]');
    if (!section) return;
    section.querySelectorAll('[data-v2-shop-tab]').forEach((item) => {
      const selected = item === tab;
      item.setAttribute('aria-selected', String(selected));
      item.tabIndex = selected ? 0 : -1;
    });
    section.querySelectorAll('[data-v2-shop-panel]').forEach((panel) => {
      const active = panel.dataset.v2ShopPanel === tab.dataset.v2ShopTab;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
    if (focus) tab.focus();
  };

  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-v2-scroll]');
    if (arrow) scrollTrack(arrow);

    const tab = event.target.closest('[data-v2-shop-tab]');
    if (tab) activateShopTab(tab);

    const row = event.target.closest('[data-v2-shop-row]');
    if (row) updateShopRow(row);

    const surface = event.target.closest('[data-v2-rug-surface]');
    if (surface) {
      const section = surface.closest('[data-v2-rugs]');
      const wall = surface.dataset.v2RugSurface === 'wall';
      section.querySelectorAll('[data-v2-rug-surface]').forEach((item) => item.classList.toggle('is-active', item === surface));
      section.querySelector('[data-v2-rug-layer]').classList.toggle('is-wall', wall);
      section.querySelector('[data-v2-rug-note]').textContent = wall
        ? 'IMG-wall-hanging · the same design hung on a sunlit wall · 4pm golden light'
        : 'VIDEO/IMG-rug-on-floor · a rug unrolled across a warm floor · 4pm golden light';
    }

    const roomOpen = event.target.closest('[data-v2-room-open]');
    if (roomOpen) openRoomDialog(roomOpen);
    const roomClose = event.target.closest('[data-v2-room-close]');
    if (roomClose) closeRoomDialog(roomClose.closest('[data-v2-room-overlay]'));
  });
  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest('[data-v2-shop-tab]');
    if (!tab) return;
    const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[data-v2-shop-tab]')];
    const index = tabs.indexOf(tab);
    let nextIndex = index;
    if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
    else if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
    else if (event.key === 'Home') nextIndex = 0;
    else if (event.key === 'End') nextIndex = tabs.length - 1;
    else return;
    event.preventDefault();
    activateShopTab(tabs[nextIndex], { focus: true });
  });
  document.addEventListener('mouseover', (event) => {
    const axis = event.target.closest('[data-he-mega-axis]');
    if (axis) updateMegaAxis(axis);

    const row = event.target.closest('[data-v2-shop-row]');
    if (row) updateShopRow(row);
  });
  document.addEventListener('focusin', (event) => {
    const axis = event.target.closest('[data-he-mega-axis]');
    if (axis) updateMegaAxis(axis);
  });

  document.querySelectorAll('[data-v2-room-overlay]').forEach((overlay) => {
    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) closeRoomDialog(overlay);
    });
    overlay.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeRoomDialog(overlay);
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = getRoomFocusable(overlay);
      if (!focusable.length) {
        event.preventDefault();
        overlay.querySelector('[data-v2-room-dialog]')?.focus();
        return;
      }
      const currentIndex = focusable.indexOf(document.activeElement);
      if (currentIndex === -1) {
        event.preventDefault();
        (event.shiftKey ? focusable.at(-1) : focusable[0]).focus();
      } else if (event.shiftKey && currentIndex === 0) {
        event.preventDefault();
        focusable.at(-1).focus();
      } else if (!event.shiftKey && currentIndex === focusable.length - 1) {
        event.preventDefault();
        focusable[0].focus();
      }
    });
  });
  document.querySelector('[data-v2-room-form]')?.addEventListener('submit', (event) => {
    event.preventDefault();
    document.querySelector('[data-v2-room-form-wrap]')?.setAttribute('hidden', '');
    const success = document.querySelector('[data-v2-room-success]');
    success?.removeAttribute('hidden');
    success?.focus();
  });

  const pill = document.querySelector('[data-v2-room-open]');
  if (pill) {
    const updatePill = () => {
      pill.classList.toggle('is-visible', window.scrollY > 640);
      header?.classList.toggle('is-scrolled', window.scrollY > 80);
    };
    updatePill();
    window.addEventListener('scroll', updatePill, { passive: true });
  } else if (header) {
    const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 80);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  const belief = document.querySelector('.home-v2-belief__inner');
  if (belief && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        belief.classList.add('is-visible');
        observer.disconnect();
      }
    }, { threshold: 0.15 });
    observer.observe(belief);
  } else {
    belief?.classList.add('is-visible');
  }
})();
